/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestConvexVlCvxExtraRewardDistribution extends Contract<ITestConvexVlCvxExtraRewardDistribution> {
  addReward: Send<(_token: AddressLike, _amount: BigNumberish) => void, ITestConvexVlCvxExtraRewardDistribution>
  'addReward(address,uint256)': Send<(_token: AddressLike, _amount: BigNumberish) => void, ITestConvexVlCvxExtraRewardDistribution>
  claimableRewards: Call<(_account: AddressLike, _token: AddressLike) => BigNumber, ITestConvexVlCvxExtraRewardDistribution>
  'claimableRewards(address,address)': Call<(_account: AddressLike, _token: AddressLike) => BigNumber, ITestConvexVlCvxExtraRewardDistribution>
}

let ITestConvexVlCvxExtraRewardDistributionBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestConvexVlCvxExtraRewardDistributionBytecode = '0x';
}

// prettier-ignore
export const ITestConvexVlCvxExtraRewardDistribution = contract<ITestConvexVlCvxExtraRewardDistribution>(ITestConvexVlCvxExtraRewardDistributionBytecode)`
  function addReward(address _token, uint256 _amount)
  function claimableRewards(address _account, address _token) view returns (uint256 amount_)
`;